// src/pages/news/NewsListPage.jsx
import Banner from '@/assets/banner/background.webp';
import PageBanner from '@/components/banner/PageBanner';
import { ContainerFluid } from '@/components/container/Container';
import NewsList from '@/components/news/NewsList';
import Seo from '@/components/seo/Seo';

export default function NewsListPage() {
  return (
    <>
      {/* ✅ SEO HALAMAN BERITA */}
      <Seo
        title="Berita & Informasi | Abdi Kerta Raharja"
        description="Berita dan informasi terbaru seputar kegiatan, produk, dan layanan Koperasi Syariah Abdi Kerta Raharja."
        canonical="https://www.abdikertaraharja.co.id/berita"
      />

      <div>
        <PageBanner
          title="Berita dan Informasi"
          description="Berita dan informasi terbaru seputar kegiatan, produk, dan layanan Koperasi Syariah Abdi Kerta Raharja."
          image={Banner}
        />

        <ContainerFluid className="py-4 lg:py-16">
          <NewsList />
        </ContainerFluid>
      </div>
    </>
  );
}
